<template>
  <el-container v-title data-title="天乔设备" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>其它功能</el-breadcrumb-item>
                <el-breadcrumb-item>天乔设备</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getTianqiaoDeviceList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="shortNo" label="设备短编号" width="100"></el-table-column>
          <el-table-column prop="longNo" label="设备长编号" width="160"></el-table-column>
          <el-table-column prop="deviceGroupName" label="设备组" width="200"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" width="120"></el-table-column>
          <el-table-column prop="modelTypeName" label="设备类型" width="120"></el-table-column>
          <el-table-column prop="customerTypeName" label="人员类型" width="110"></el-table-column>
          <el-table-column prop="faceCount" label="人脸数" width="65"></el-table-column>
          <el-table-column prop="connectionStatus" label="连接状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.connectionStatus === '1'" style="color:green">连接</span>
              <span v-if="scope.row.connectionStatus === '0'" style="color:red">断开</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="openFaceListDialog(scope.row.id)">设备人员</el-button>
              <el-button type="text" @click="openModifyDeviceNameDialog(scope.row.id, scope.row.deviceGroupName, scope.row.deviceName)">修改设备名称</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getTianqiaoDeviceList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（设备人员列表） -->
      <el-dialog
        title="设备人员列表"
        :visible.sync="faceListDialogVisible"
        width="950px"
        :before-close="handleClose">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-main>
              <el-form :inline="true" :model="searchFormInner" class="demo-form-inline" >
                <el-form-item label="姓名" prop="realName">
                  <el-input v-model="searchFormInner.realName" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idCardno">
                  <el-input v-model="searchFormInner.idCardNo" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSizeInner" @change="handleSizeChangeInner" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getTianqiaoDeviceFaceList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableDataInner" border stripe>
          <el-table-column prop="userId" label="用户id" width="100"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="140"></el-table-column>
          <el-table-column prop="idCardNo" label="身份证号码" width="140"></el-table-column>
          <el-table-column label="人脸图" width="80">
            <template slot-scope="scope">
              <img :src="GLOBAL.picUrl + scope.row.facePicUrl" width="60" height="60" @click="openPicDialog(GLOBAL.picUrl + scope.row.facePicUrl)"/>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChangeInner"
            @current-change="getTianqiaoDeviceFaceList"
            :current-page.sync="currentPageInner"
            :page-sizes="pageSizes"
            :page-size="pageSizeInner"
            :total="totalInner"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-dialog>
      <!-- 弹窗页（修改设备名称） -->
      <el-dialog
        title="修改设备名称"
        :visible.sync="modifyDeviceNameDialogVisible"
        width="450px"
        :before-close="handleClose">
        <el-form label-width="180px">
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="newDeviceName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyDeviceName()">修改</el-button>
            <el-button @click="modifyDeviceNameDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（人脸图） -->
      <el-dialog
        :visible.sync="picDialogVisible"
        :width="widthOfPicDialog"
        :before-close="handleClose"
        :close-on-click-modal="true">
        <img :src="picUrlOnPicDialog" />
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          let todaysZero = new Date()
          // todaysZero.setHours(0, 0, 0, 0)
          return time.getTime() < todaysZero
        }
      },
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: null,
        status: ''
      },
      searchFormInner: {
        realName: '',
        idCardNo: ''
      },
      faceListDialogVisible: false,
      tableDataInner: [],
      currentPageInner: 1,
      pageSizeInner: 15,
      totalInner: 0,
      deviceId: null,
      picDialogVisible: false,
      picUrlOnPicDialog: '',
      widthOfPicDialog: '200px',
      modifyDeviceNameDialogVisible: false,
      deviceGroupName: '',
      deviceName: '',
      newDeviceName: ''
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    openPicDialog (picUrl) {
      let img = new Image()
      img.src = picUrl
      let _this = this
      img.onload = function () {
        _this.widthOfPicDialog = this.width + 40 + 'px'
      }
      this.picUrlOnPicDialog = picUrl
      this.picDialogVisible = true
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getTianqiaoDeviceList()
    },
    handleSizeChangeInner (pageSize) {
      this.pageSizeInner = pageSize
      this.getTianqiaoDeviceFaceList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getTianqiaoDeviceList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getTianqiaoDeviceList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/tianqiaoDevice/list', {
        schoolId: _this.searchForm.schoolId,
        page: _this.currentPage,
        size: _this.pageSize
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    openFaceListDialog (deviceId) {
      this.faceListDialogVisible = true
      this.deviceId = deviceId
      this.totalInner = 0
      this.tableInner = []
      this.getTianqiaoDeviceFaceList()
    },
    getTianqiaoDeviceFaceList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/tianqiaoDeviceFace/list', {
        schoolId: _this.searchForm.schoolId,
        deviceId: _this.deviceId,
        realNameLike: _this.searchFormInner.realName,
        idCardNoLike: _this.searchFormInner.idCardNo,
        page: _this.currentPageInner,
        size: _this.pageSizeInner
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200 && res.data.data != null) {
            _this.totalInner = res.data.data.total
            _this.tableDataInner = res.data.data.list
          }
          _this.loading = false
        }
      })
    },
    openModifyDeviceNameDialog (deviceId, deviceGroupName, deviceName) {
      this.deviceId = deviceId
      this.deviceGroupName = deviceGroupName
      this.deviceName = deviceName
      this.newDeviceName = deviceName
      this.modifyDeviceNameDialogVisible = true
    },
    modifyDeviceName () {
      if (this.deviceName === this.newDeviceName) return
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/tianqiaoDevice/updateDeviceName', {
        id: _this.deviceId,
        deviceGroupName: _this.deviceGroupName,
        deviceName: _this.newDeviceName
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message.success(res.data.message)
            _this.getTianqiaoDeviceFaceList()
          } else {
            this.$message.error(res.data.message)
          }
          _this.loading = false
          _this.modifyDeviceNameDialogVisible = false
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/TianqiaoDevice.vue